import { render, staticRenderFns } from "./MonumentTile.vue?vue&type=template&id=46e2198a&scoped=true&"
import script from "./MonumentTile.vue?vue&type=script&lang=js&"
export * from "./MonumentTile.vue?vue&type=script&lang=js&"
import style0 from "./MonumentTile.vue?vue&type=style&index=0&id=46e2198a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e2198a",
  null
  
)

export default component.exports